import React from "react";
import styled from "styled-components/macro";
import { Grid, TextField as MuiTextField } from "@material-ui/core";
import { spacing } from "@material-ui/system";

const TextField = styled(MuiTextField)<{ my?: number }>(spacing);

export const NameField = ({
    errors,
    handleBlur,
    handleChange,
    touched,
    values,
}: {
    errors: any;
    handleBlur: any;
    handleChange: any;
    touched: any;
    values: any;
}) => {
    return (
        <Grid container spacing={6}>
            <Grid item md={12}>
                <TextField
                    name="name"
                    label="Name"
                    value={values.name || ""}
                    error={Boolean(touched.name && errors.name)}
                    fullWidth
                    helperText={touched.name && errors.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    variant="outlined"
                    my={2}
                    placeholder="My name"
                    required
                />
            </Grid>
        </Grid>
    );
};
